"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VendorEventLandingPageActions;
(function (VendorEventLandingPageActions) {
    VendorEventLandingPageActions["DataLoaded"] = "DataLoaded";
})(VendorEventLandingPageActions || (VendorEventLandingPageActions = {}));
exports.default = VendorEventLandingPageActions;
